<div class="container" [ngClass]="[percentageClass, circleColor]" [ngStyle]="{ 'font-size': circleSize }">
  <div class="slice">
    <div class="bar"></div>
    <div class="fill"></div>
  </div>
</div>
